import Popper from 'node_modules/@material-ui/popper.js';
window.Popper = Popper;

window.bootstrap = require('node_modules/bootstrap/dist/js/bootstrap.bundle.js');

import jQuery from 'node_modules/jquery';
window.jQuery = window.$ = jQuery;

import {App} from './App.js';
window.App = App;